import React, { Component } from 'react';
import Translate from 'react-translate-component';
import PropTypes from 'prop-types';
import { Form } from 'antd';
import { formItemLayout } from 'constants/formItemLayout';

export default class FieldWithLabel extends Component {
    static defaultProps = {
        labelClass: 'wrapped-field-default',
        labelCol: formItemLayout.labelCol,
        wrapperCol: formItemLayout.wrapperCol,
        required: false
    };

    static propTypes = {
        label: PropTypes.string.isRequired,
        labelClass: PropTypes.string,
        labelCol: PropTypes.object,
        wrapperCol: PropTypes.object,
        required: PropTypes.bool,
        children: PropTypes.node,
    };

    render() {
        const {
            label,
            labelClass,
            labelCol,
            wrapperCol,
            required,
        } = this.props;
        const translation = <Translate content={label} />;

        return this.props.children ? (
            <Form.Item
                className={labelClass}
                label={translation}
                labelCol={labelCol}
                wrapperCol={wrapperCol}
                required={required}
            >
                { this.props.children }
            </Form.Item>
        ) : null;
    }
}
